export default "__VITE_ASSET__b9f2ec5e__"